import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useConsoleAuth } from '../hooks/useConsoleAuth';

interface Props {
  children: React.ReactNode;
}

export const ConsoleAuthGate: React.FC<Props> = ({ children }) => {
  const { loading, gate } = useConsoleAuth();
  const location = useLocation();

  if (loading) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (gate?.reason === 'unauthenticated') {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  if (gate?.reason === 'not_super_admin') {
    return <Navigate to="/access-denied" replace />;
  }
  if (gate?.reason === 'mfa_required') {
    return <Navigate to="/mfa-verify" replace />;
  }

  return <>{children}</>;
};
